import { render, staticRenderFns } from "./HomeTvTypes.vue?vue&type=template&id=5b4573be&"
import script from "./HomeTvTypes.vue?vue&type=script&lang=js&"
export * from "./HomeTvTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports